var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconClose = function SvgIconClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.317,
    height: 25.317,
    viewBox: "0 0 25.317 25.317",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M30.163,5.988a1.912,1.912,0,0,0-2.707,0l-9.39,9.37-9.39-9.39A1.914,1.914,0,0,0,5.969,8.677l9.39,9.39-9.39,9.39a1.914,1.914,0,1,0,2.707,2.707l9.39-9.39,9.39,9.39a1.914,1.914,0,1,0,2.707-2.707l-9.39-9.39,9.39-9.39A1.924,1.924,0,0,0,30.163,5.988Z",
    transform: "translate(-5.407 -5.408)",
    fill: "#fff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_close.66d38c6c.svg";
export { ForwardRef as ReactComponent };